/**
 * Denis Callinan
 * Project Andromeda
 * August 2nd, 2020
 * ExpGrid.js - Experience component
 */

import React from 'react';
import './ExpBox.css';

export default class ExpBox extends React.Component {
    render() {

        var photos = this.props.photos.map(photo => {
            return <img id = "exp-photo" src = {require("../../img/exp/" + photo)} alt = "Experience"/>
        })

        return(
            <div className = "expComponent">
                <h4 className = "expText">{this.props.title}</h4>
                <p className = "expText"><i>{this.props.time}</i></p>
                <p className = "expText">{this.props.desc}</p>
                <div className = "expList" id = {this.props.photos.length === 3 ? (this.props.width > 950 ? "exp-3": "exp-1"): "exp-1"}>
                    {photos}
                </div>
            </div>
        );
    }
}